export default "__VITE_ASSET__DleG$6zR__"